/*****************************************************************************
*
* MCAFEE CONFIDENTIAL
* Copyright (c)2020 McAfee, LLC
*
* The source code contained or described herein and all documents related
* to the source code ("Material") are owned by McAfee or its
* suppliers or licensors. Title to the Material remains with McAfee
* or its suppliers and licensors. The Material contains trade
* secrets and proprietary and confidential information of McAfee or its
* suppliers and licensors. The Material is protected by worldwide copyright
* and trade secret laws and treaty provisions. No part of the Material may
* be used, copied, reproduced, modified, published, uploaded, posted,
* transmitted, distributed, or disclosed in any way without McAfee's prior
* express written permission.
*
* No license under any patent, copyright, trade secret or other intellectual
* property right is granted to or conferred upon you by disclosure or
* delivery of the Materials, either expressly, by implication, inducement,
* estoppel or otherwise. Any license under such intellectual property rights
* must be expressed and approved by McAfee in writing.
*
****************************************************************************/

/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack
 
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";
import { getPluginFactory } from "./bootstrap_web_ext";
import { engine } from "./engine";
import { globalEngine, ModuleManager } from "./Init";

// #ENDIF WebPack
function CreateXMLHttpWrapper()
{
    var xmlHttpCom = {
        "_xmlHttpComObj": null,
        "_selectedObjName": null,
        "_useArggumentsInReverse": false,
        "setup": function()
        {
            // TODO: Check if this is still needed
            try
            {
                var xmlHttpList = [ 'Microsoft.XMLHTTP',
                    'MSXML2.XMLHTTP.6.0',
                    'MSXML2.XMLHTTP.3.0',
                    'Msxml2.XMLHTTP',
                    'Microsoft.XMLHTTP.1.0'
                ];

                var xmlHttpComObj = null;
                var selectedObjName = null;
                
                for (var idx in xmlHttpList)
                {
                    try
                    {
                        selectedObjName = xmlHttpList[idx];
                        var selectedObj = engine.clsidFromProgId(selectedObjName)
                        if (!selectedObj)
                        {
                            continue;
                        }

                        xmlHttpComObj = getPluginFactory().CreateFromGuid(selectedObj, true);
                        if (xmlHttpComObj)
                        {
                            logInformation('xmlHttpCom:setup selectedObjName(' + selectedObjName + '). CLSID(' + selectedObj + ')');
                            break;
                        }
                    }
                    catch (e)
                    {
                        logError('xmlHttpCom:setup: Exception caught while trying to create xmlhttpCom: ' + e.message);
                    }
                }
                // For old versions of the SDK, CreateFromGuid results in an object that requires arguments to be passed in reverse
                // If this is an old version of the SDK, treat the objects differently
                this._checkIfUserArgumentsInReverse();
            }
            catch (e)
            {
                logError('xmlHttpCom:setup: Exception caught while trying to create xmlhttpCom: ' + e.message);
            }

            if (!xmlHttpComObj)
            {
                logError('xmlHttpCom:setup: couldnt create a xmlhttpcom');
                this._reportNoComObjCreatedTelemetry();
                return false;
            }

            this._xmlHttpComObj = xmlHttpComObj;
            this._selectedObjName = selectedObjName;
            return true;
        },
        "_checkIfUserArgumentsInReverse": function()
        {
            try
            {
                // WMI plugin version 1 and 2 belongs to the SDK that had a bug in CreateFromGuid
                var wmiPlugin = getPluginFactory().Create("wmi");
                if (!wmiPlugin)
                {
                    logError('_checkIfUserArgumentsInReverse: no plugin');
                    return;
                }
                var version = wmiPlugin.GetVersion();

                if(version.match('^(1|2)$'))
                {
                    this._useArggumentsInReverse = true;
                }
            }
            catch(e)
            {
                // do nothing
            }
        },
        "open": function(method, url, async)
        {
            try
            {
                if(!this._xmlHttpComObj)
                {
                    this._logError('open: _xmlHttpComObj is null');
                    return;
                }

                if(this._useArggumentsInReverse)
                {
                    return this._xmlHttpComObj.open(async, url, method);
                }

                return this._xmlHttpComObj.open(method, url, async);
            }
            catch(e)
            {
                this._logError('open: ' + e.message);
            }
        },
        "setRequestHeader": function(header, value)
        {
            try
            {
                if(!this._xmlHttpComObj)
                {
                    this._logError('setRequestHeader: _xmlHttpComObj is null');
                    return;
                }

                if(this._useArggumentsInReverse)
                {
                    return this._xmlHttpComObj.setRequestHeader(value, header);
                }

                return this._xmlHttpComObj.setRequestHeader(header, value);
            }
            catch(e)
            {
                this._logError('setRequestHeader: ' + e.message);
            }
        },
        "send": function(body)
        {
            try
            {
                if(!this._xmlHttpComObj)
                {
                    this._logError('send: _xmlHttpComObj is null');
                    return;
                }

                return this._xmlHttpComObj.send(body);
            }
            catch(e)
            {
                this._logError('send: ' + e.message);
            }
        },
        "getResponseHeader": function(headerName)
        {
            try
            {
                if(!this._xmlHttpComObj)
                {
                    this._logError('getResponseHeader: _xmlHttpComObj is null');
                    return;
                }

                return this._xmlHttpComObj.getResponseHeader(headerName);
            }
            catch(e)
            {
                this._logError('getResponseHeader: ' + e.message);
            }
        },
        "getAllResponseHeaders": function()
        {
            try
            {
                if(!this._xmlHttpComObj)
                {
                    this._logError('getAllResponseHeaders: _xmlHttpComObj is null');
                    return;
                }

                return this._xmlHttpComObj.getAllResponseHeaders();
            }
            catch(e)
            {
                this._logError('getAllResponseHeaders: ' + e.message);
            } 
        },
        "getSelectedObjName": function()
        {
            return this._selectedObjName; 
        },

        "_logInfo": function (msg)
        {
            logInformation('xmlHttpCom: ' + msg);
        },
        "_logError": function (msg)
        {
            logError('xmlHttpCom: ' + msg);
        }
    };
    return xmlHttpCom;
};

ModuleManager.registerFactory("xmlHttpComObj", CreateXMLHttpWrapper);
//export {CreateXMLHttpWrapper};
//globalEngine.FactoryMap["xmlHttpComObj"] =  CreateXMLHttpWrapper;
